import { FC } from 'react';
import { IntlFormattedMessage } from 'src/common/components/IntlFormattedMessage';
import { media } from 'src/common/styles/breakpoints';
import { typography } from 'src/common/styles/typography';
import styled, { css } from 'styled-components';

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  font-family: ${typography.fontFamilyDefault};
  line-height: 1.25em;

  ${media.w.min.px576(css`
    font-size: 2rem;
  `)}
`;

const Description = styled.h2`
  margin: 1.5rem 0;
  font-size: 1rem;
  font-weight: 400;
  color: ${({ theme }) => theme.text.secondary};
  font-family: ${typography.fontFamilyDefault};

  ${media.w.min.px576(css`
    font-size: 1rem;
  `)};
`;

interface MainPageHeadingProps {
  headingMsgId: MessageId;
  descriptionMsgId?: MessageId;
}

const MainPageHeading: FC<MainPageHeadingProps> = ({
  headingMsgId,
  descriptionMsgId,
}) => {
  return (
    <>
      <Title>
        <IntlFormattedMessage id={headingMsgId} />
      </Title>
      {descriptionMsgId && (
        <Description>
          <IntlFormattedMessage id={descriptionMsgId} />
        </Description>
      )}
    </>
  );
};

export default MainPageHeading;
